
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demos",
      function () {
        return require("private-next-pages/demos.tsx");
      }
    ]);
  